import { useIsUngated } from '../../../hooks/useIsUngated';
import { IA_KILL_SWITCH_GATE } from '../constants/gates';
import { OptInOptOutAccountMenuItem } from './OptInOptOutAccountMenuItem';
import { useAppSelector } from '../../../hooks';
import { selectIADetails } from '../selectors/iaDetails.selectors';
import { withErrorBoundary } from '../../../components/ErrorBoundary';
import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import { jsx as _jsx } from "react/jsx-runtime";
const _MaybeOptInOptOutAccountMenuItem = () => {
  const isIAEnabled = useIsUngated(IA_KILL_SWITCH_GATE);
  const {
    isOptedInToIA
  } = useAppSelector(selectIADetails);
  if (!isIAEnabled) {
    return null;
  }
  if (isOptedInToIA === null) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "nav-ia-opt-in-opt-out-account-menu-item",
    children: /*#__PURE__*/_jsx(OptInOptOutAccountMenuItem, {})
  });
};
export const MaybeOptInOptOutAccountMenuItem = withErrorBoundary(memoWithDisplayName('MaybeOptInOptOutAccountMenuItem', _MaybeOptInOptOutAccountMenuItem), {
  boundaryName: 'MaybeOptInOptOutAccountMenuItem'
});